import React from 'react';
import {
  PAYMENT_ACCESS_BLOCKED_MESSAGE,
  PAYMENT_ACCESS_BLOCKED_TITLE,
} from './paymentStatus';


const safeDashboardUrl = value => {
  if (typeof value !== 'string' || !/^https?:\/\//i.test(value)) return null;
  return value;
};


const PaymentAccessBlockedDialog = ({detail = {}, onClose, onAdminAccess}) => {
  const dashboardUrl = safeDashboardUrl(detail.payment_dashboard_url);

  return (
    <div
      className="fixed inset-0 z-[100] flex items-start justify-center overflow-y-auto bg-black/60 p-4 py-10"
      role="dialog"
      aria-modal="true"
      aria-labelledby="payment-access-blocked-title"
    >
      <div className="w-full max-w-lg rounded-xl border-2 border-red-300 bg-white p-6 shadow-2xl sm:p-8">
        <div className="mb-5 text-center">
          <div className="mb-3 text-4xl" aria-hidden="true">⚠️</div>
          <h2 id="payment-access-blocked-title" className="text-2xl font-bold text-red-900">
            {detail.title || PAYMENT_ACCESS_BLOCKED_TITLE}
          </h2>
        </div>

        <p className="leading-7 text-slate-700">
          {detail.message || PAYMENT_ACCESS_BLOCKED_MESSAGE}
        </p>

        {detail.user_username && (
          <div className="mt-6 rounded-lg border border-amber-300 bg-amber-50 p-4 text-amber-950">
            <p className="font-semibold">Payment-Dashboard Zugang</p>
            <code className="mt-2 inline-block rounded border bg-white px-2 py-1 text-sm">
              Username: {detail.user_username}
            </code>
            <p className="mt-2 text-sm">
              <strong>Passwort: Das Passwort ist identisch mit dem Username.</strong>
            </p>
            {dashboardUrl && (
              <a
                href={dashboardUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex rounded-lg bg-amber-700 px-4 py-2 font-medium text-white hover:bg-amber-800"
              >
                Zahlungsstatus öffnen
              </a>
            )}
          </div>
        )}

        {onAdminAccess && (
          <button
            type="button"
            onClick={onAdminAccess}
            className="mt-6 w-full rounded-lg bg-red-700 px-4 py-2.5 font-medium text-white hover:bg-red-800"
          >
            Zahlungsstatus als Admin öffnen
          </button>
        )}

        <button
          type="button"
          onClick={onClose}
          className={`${onAdminAccess ? 'mt-3' : 'mt-6'} w-full rounded-lg bg-slate-800 px-4 py-2.5 font-medium text-white hover:bg-slate-700`}
        >
          Schließen
        </button>
      </div>
    </div>
  );
};


export default PaymentAccessBlockedDialog;
